module.exports = __webpack_public_path__ + "static/SP-stand-alone-energy-monitor-spec-sheet-4d66fb5da87ba8108dab81f22f98dcb5.pdf";